import { IWorkplaceDataService } from "../../core/workplaces.dataservice";
import { Ng2StateDeclaration } from "@uirouter/angular";
import { Workplaces } from "./workplaces.component";
import { EditWorkplace } from "./workplace.edit.component";
import { Workplace } from "./workplace.component";

/**
 * This state displays all Workplaces
 */
export const workplacesState: Ng2StateDeclaration = {
    name: "app.settings.workplaces",
    url: "/workplaces",
    views: {
        "main-view@app": {
            component: Workplaces
        }
    },
    resolve: {
        workplaces: ["workplaceDataService", (workplaceDataService: IWorkplaceDataService) => {
            return workplaceDataService.getAll();
        }]
    }
};

/**
 * This state is for creating a new Workplace
 */
export const newWorkplaceState: Ng2StateDeclaration = {
    name: "app.settings.workplaces.new",
    url: "/new",
    views: {
        "main-view@app": {
            component: EditWorkplace
        }
    },
    resolve: {
        workplace: function () {
            return <Nema.Crew.Model.Workplace>{ Id: -1, ExternalId: -1, Name: "", Active: true, SortTag: "", Activities: null, CompetenceRequirementCollectionWorkplaces: null, CompetenceRequirementCompetenceTypes: null, ManualActivityAdjustments: null, PersonWorkplaces: null, WorkGroups: null };
        },
        isNew: function () {
            return true;
        }
    }
};

/**
 * This state is for editing a Workplace
 */
export const editWorkplaceState: Ng2StateDeclaration = {
    name: "app.settings.workplaces.edit",
    url: "/{id:int}/edit",
    views: {
        "main-view@app": {
            component: EditWorkplace
        }
    },
    resolve: {
        workplace: ["workplaceDataService", "$stateParams", function (workplaceDataService: IWorkplaceDataService, $stateParams) {
            return workplaceDataService.get($stateParams.id);
        }],
        isNew: function () {
            return false;
        }
    }
};

/**
 * Workplace Details state
 */
export const workplaceState: Ng2StateDeclaration = {
    name: "app.settings.workplaces.detail",
    url: "/{id:int}",
    views: {
        "main-view@app": {
            component: Workplace
        }
    },
    resolve: {
        workplace: ["workplaceDataService", "$stateParams", function (workplaceDataService: IWorkplaceDataService, $stateParams) {
            return workplaceDataService.get($stateParams.id);
        }]
    }
};


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/settings/workplaces/workplaces.states.ts